module.exports = __webpack_public_path__ + "static/img/34-3.0ac90e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/34-3.jpg
// module id = eYsG
// module chunks = 0